"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getQueryKey = _interopRequireDefault(require("../../../partner_cart_reviews/v1/get-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Updates partner cart reviews v1 totals
 *
 * @param {object} params - named parameters
 * @param {object} params.queryClient - the query client
 * @param {number} params.summarySubtotal - subtotal amount
 * @param {number} params.summaryTotal - total amount
 */
var updatePartnerCartReviewsV1 = function updatePartnerCartReviewsV1(_ref) {
  var _partnerCartReviews$t;
  var queryClient = _ref.queryClient,
    summarySubtotal = _ref.summarySubtotal,
    summaryTotal = _ref.summaryTotal;
  var isCartEmpty = summaryTotal === 0 && summarySubtotal === 0;
  var partnerCartReviews = queryClient.getQueryData((0, _getQueryKey["default"])());
  var summaryShippingTotal = isCartEmpty ? 0 : (partnerCartReviews === null || partnerCartReviews === void 0 || (_partnerCartReviews$t = partnerCartReviews.totals) === null || _partnerCartReviews$t === void 0 ? void 0 : _partnerCartReviews$t.shippingTotal) || 0;
  queryClient.setQueryData((0, _getQueryKey["default"])(), function (partnerCartReviews) {
    return _objectSpread(_objectSpread({}, partnerCartReviews), {}, {
      totals: {
        subtotal: summarySubtotal,
        taxTotal: 0,
        taxTotalDetails: {
          internationalCharges: 0,
          internationalChargesType: 'NOT_APPLICABLE'
        },
        discountTotal: 0,
        total: summaryTotal + summaryShippingTotal,
        shippingTotal: summaryShippingTotal
      }
    });
  });
};
var _default = exports["default"] = updatePartnerCartReviewsV1;